import {Button} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonEditProduct(props) {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    if (! (
        // 快照
        map.data.dataId &&
        1 === selectedNodes.size
    )) {
        return null
    }

    const handleClick = async e => {
        const [node] = selectedNodes
        const _n = map.nodeProxy(node)
        const target = e.altKey ? '_self' : '_blank'
        await _n.gotoCurrent(target)
    }

    return (
        <Button
            onClick={handleClick}
            {...props}
        >
            编辑
        </Button>
    )
}
